import React from 'react';
import { SparklesIcon } from 'lucide-react';
type CtaButtonProps = {
  compact?: boolean;
  tone?: 'clay' | 'cream';
  className?: string;
};
export function CtaButton({
  compact = false,
  tone = 'clay',
  className = ''
}: CtaButtonProps) {
  const palette = tone === 'clay' ? 'bg-clay text-cream hover:bg-clay-dark focus-visible:outline-clay' : 'bg-cream text-plum hover:bg-sand focus-visible:outline-cream';
  if (compact) {
    return <a href="#comprar" className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full px-6 py-3 font-sans text-sm font-semibold transition-[background-color,transform] duration-150 ease-soft active:translate-y-px focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${palette} ${className}`} data-id="element-36" data-mp="qiha3qks2jlw">
        <SparklesIcon aria-hidden="true" className="h-4 w-4 shrink-0" data-id="element-37" data-mp="19busyxb7uzl5" />
        Quiero el Kit por $18.900
      </a>;
  }
  return <a href="#comprar" className={`group inline-flex w-full max-w-xl flex-col items-center rounded-2xl px-8 py-5 text-center transition-[background-color,transform] duration-150 ease-soft active:translate-y-px focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 sm:w-auto ${palette} ${className}`} data-id="element-38" data-mp="157n5f3ghvpoi">
      <span className="flex items-center gap-2 font-sans text-base font-semibold leading-tight sm:text-lg" data-id="element-39" data-mp="3jx75bgi5n1si">
        <SparklesIcon aria-hidden="true" className="h-5 w-5 shrink-0" data-id="element-40" data-mp="3ouyw2772chv4" />
        ¡Sí, quiero profesionalizar mis sesiones!
      </span>
      <span className="mt-1 font-sans text-sm opacity-80" data-id="element-41" data-mp="3svivxij0tzky">
        Acceso inmediato por $18.900 ARS — pago único
      </span>
    </a>;
}